import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';

export type Getters = {
  currentTab(state: State): number;
  loadConfig(state: State): boolean;
}

export const getters: GetterTree<State, RootState> & Getters = {
  currentTab: (state) => state.currentTab,
  loadConfig: (state) => state.loadConfig,
};
